import script from "./Permission_Parameter_button.vue?vue&type=script&setup=true&lang=js"
export * from "./Permission_Parameter_button.vue?vue&type=script&setup=true&lang=js"

import "./Permission_Parameter_button.vue?vue&type=style&index=0&id=704a23da&lang=scss"

const __exports__ = script;

export default __exports__